<template>
	<v-layout>
		<v-flex xs12>
			<confirmation-header-text class="ml-2" icon="mdi-attachment" text="Identity Documents"/>
			<v-layout class="pl-6" row>
				<v-flex sm3 v-for="(document, key) in document_list" :key="key">
					<v-list class="pa-0" two-line>
						<v-list-item class="pl-0">
							<v-list-item-content>
								<v-list-item class="px-0">
									<template v-slot:default="{ active }">
										<v-list-item-action class="ma-0" v-if="!is_verified">
											<v-tooltip top>
												<template v-slot:activator="{ on }">
													<v-btn
															@click="replaceDocument(document.document_type)"
															class="mr-2"
															color="#FF8316"
															dark
															v-on="on"
															fab
															x-small
															elevation="0"
													>
														<v-icon small>edit</v-icon>
													</v-btn>
												</template>
												<span>Replace {{ document.document_type }}</span>
											</v-tooltip>
										</v-list-item-action>

										<v-list-item-content class="py-1">
											<v-list-item-subtitle style="font-size: 12px; user-select: text;">{{
													document.document_type
												}}
											</v-list-item-subtitle>
											<div v-if="document.autofill" class="caption" style="font-size: 10px; user-select: text;">
												- Autofilled
											</div>
										</v-list-item-content>
									</template>
								</v-list-item>

								<file-display :src="document.path" :avatar="false"/>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-flex>
			</v-layout>
		</v-flex>

		<v-dialog
				class="hide-on-print"
				v-model="editDocumentDialog"
				persistent
				width="800">

			<v-card class="hide-on-print">
				<v-toolbar color="blue darken-3" dark>
					<v-toolbar-title>Replace Document</v-toolbar-title>
				</v-toolbar>
				<v-card-text class="pb-0">
					<v-form class="px-2" lazy-validation ref="replaceDocumentRef">
						<v-layout row wrap>
							<v-flex xs12 class="mt-4">
								<v-file-input
										outlined
										show-size
										label="Document"
										v-model="formData.replace_document"
										:rules="[rules.required]"
								></v-file-input>
							</v-flex>
							<v-flex xs12 class="red--text">
								Maximum upload limit is 4 MB
							</v-flex>
						</v-layout>
					</v-form>

				</v-card-text>
				<v-divider style="margin-top:10px;"/>
				<v-card-actions>
					<v-spacer/>
					<v-btn
							@click="cancel"
							class="white--text"
							color="red darken-3"
					>Cancel
					</v-btn>
					<v-btn
							@click="save"
							:loading="loading"
							class="white--text"
							color="blue darken-3"
					>Save
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import FileListItemDetail from "../components/FileListItemDetail";
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";
import FileDisplay from "./FileDisplay";
import {validationMixin} from "../mixins/validationMixin";
import Http from "axios";
import {VERSIONED_API_URL} from "../config/config";
import {buildFormData} from "../helpers/FormedData";

export default {
	name: "AttachedRequiredDocument",
	props: ["document_list", "submission_no", "is_verified"],
	mixins: [validationMixin],
	components: {
		ConfirmationHeaderText,
		FileListItemDetail,
		FileDisplay,
	},
	data() {
		return {
			editDocumentDialog: false,
			formData: {
				replace_document: null,
				document_index: null,
			},
			loading: false,
		}
	},
	methods: {
		resetFormData() {
			this.formData = {
				replace_document: null,
				document_index: null
			}
		},
		replaceDocument(index) {
			this.editDocumentDialog = true;
			this.formData.document_index = index;
		},
		async save() {
			if (this.$refs.replaceDocumentRef.validate() && this.formData.replace_document) {
				try {
					this.loading = true;
					const formData = new FormData();
					buildFormData(formData, this.formData);

					const response = await Http.post(`${VERSIONED_API_URL}/visa-requests/replace-document/${this.submission_no}`, formData);
					await this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.submission_no);
					this.$store.commit('Notification/showSuccess', response.data.message);
					this.resetFormData();
					this.loading = false;
					this.cancel();
				} catch (e) {
					this.$store.commit('Notification/showError', e.response.data.message);
					this.loading = false;
				}
			} else {
				this.$store.commit('Notification/showError', 'File is required');
			}
		},

		cancel() {
			this.editDocumentDialog = false;
		}
	},
};
</script>
